import {Entidade} from "./Entidade";

export default class GrupoBebida extends Entidade {

    nome?: string;

}